import { apiUrl } from "@/api/api";
import { Persona } from "@/api/personas";
import { PersonaImageAvatar } from "@/components/PersonaImageAvatar";
import { H6 } from "@/components/ui/h6";

export function TwitterAvatar({
  persona,
}: {
  persona: Pick<
    Persona,
    "persona_id" | "name" | "avatar_id" | "twitter" | "gender"
  >;
}) {
  return (
    <div className="flex flex-row items-center mb-3">
      <PersonaImageAvatar
        className="mr-2"
        altText={persona?.name}
        src={
          persona.avatar_id !== ""
            ? `${apiUrl}/get-file?url=persona-knowledge-base/${persona.persona_id}/${persona.avatar_id}`
            : undefined
        }
        gender={persona?.gender}
      />
      <div className="flex flex-col h-full justify-center">
        <H6 className="leading-5 text-sm font-semibold">{persona?.name}</H6>
        {persona?.twitter ? (
          <span className="font-light text-sm">@{persona.twitter}</span>
        ) : null}
      </div>
    </div>
  );
}
